import React from 'react';

const MainWrapper = (props) => {

    return (
        <>
            <div id="main-live" className="header-live">
                <div className="clear"/>
            </div>
            <div className="main-live-wrapper">
                <div className="main-live-body">
                    {props.children}
                </div>
            </div>
        </>
    );
};

export default MainWrapper;